import MessageList from './MessageList';
import messageListEventBus from './messageListEventBus';

export default MessageList;

export { messageListEventBus };
